import { Divider as MuiDivider } from '@mui/material';

import type { DividerProps as MuiDividerProps } from '@mui/material';

export function Divider({
  orientation = 'horizontal',
  sx,
  ...props
}: MuiDividerProps) {
  const dividerSx =
    orientation === 'vertical'
      ? {
          borderRight: '1px solid var(--nn-color-input-border)',
          height: '100%',
          ...sx,
        }
      : {
          borderColor: 'var(--nn-color-input-border)',
          ...sx,
        };

  return <MuiDivider {...props} orientation={orientation} sx={dividerSx} />;
}
